<div
  *ngIf="product_categories.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header__no-summary">
  <table
    mat-table
    [dataSource]="product_categories"
    class="sp-width__full">
    <ng-container matColumnDef="product_category_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PRODUCT_CATEGORY.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let category">
        <app-shared-id
          [content]="category.product_category_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PRODUCT_CATEGORY.NAME_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let category">
        <span class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{ category.name }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="decido_evaluation_code">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PRODUCT_CATEGORY.DECIDO_EVALUATION_CODE_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let category">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ category.decido_evaluation_code || '-' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PRODUCT_CATEGORY.CREATED_AT_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let category">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ category.created_at | date : 'shortDate' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PRODUCT_CATEGORY.ACTIONS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let category">
        <div class="sp-row__align">
          <button
            mat-icon-button
            class="sp-icon__button sp-icon__button-dark sp-margin__left"
            [matTooltip]="'PRODUCT_CATEGORY.SUBCATEGORIES_TOOLTIP' | translate">
            <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
          </button>

          <button
            (click)="$event.stopPropagation()"
            mat-icon-button
            class="sp-icon__button sp-icon__button-accent sp-margin__left"
            [mat-menu-trigger-for]="categories_actions_menu">
            <mat-icon> more_horiz </mat-icon>
          </button>

          <mat-menu #categories_actions_menu="matMenu">
            <button
              (click)="onEditClick(category); $event.stopPropagation()"
              class="sp-padding__vert"
              mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__accent"> edit </mat-icon>
              <span> {{ 'PRODUCT_CATEGORY.EDIT_CTA' | translate }} </span>
            </button>

            <button
              (click)="onStepsEditClick(category); $event.stopPropagation()"
              class="sp-padding__vert"
              mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__accent"> apps </mat-icon>
              <span> {{ 'PRODUCT_CATEGORY.EDIT_STEPS_CTA' | translate }} </span>
            </button>

            <button
              (click)="onDeleteClick(category); $event.stopPropagation()"
              class="sp-padding__vert"
              mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__warn"> delete </mat-icon>
              <span> {{ 'PRODUCT_CATEGORY.DELETE_CTA' | translate }} </span>
            </button>
          </mat-menu>
        </div>
      </td>
    </ng-container>
    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      class="sp-cursor__pointer"
      *matRowDef="let row; columns: displayed_columns"
      (click)="onDetailsClick(row)"></tr>
  </table>
</div>
